module.exports = __webpack_public_path__ + "img/undraw_App_wireframe_re_d467.f55b8623.svg";